import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConstants } from './app.constants';
import { LicenseService } from './core/services/http-services/license.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  public isPendingLicenseStatus: boolean = false;

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private readonly licenseService: LicenseService
  ) {
    AppConstants.ICONS.forEach((icon) => {
      iconRegistry.addSvgIcon(
        icon.name,
        sanitizer.bypassSecurityTrustResourceUrl(icon.path)
      );
    });

    this.licenseService.initLicenseStatusSubscription();
    this.licenseService.isStatusInPending.subscribe((isInPending: boolean) => this.isPendingLicenseStatus = isInPending);
  }
}
